import LayoutSetLevelZero from 'components/ui/layout-set/general/layout-set-level-zero';
import PageSysAdminInstancesList from 'components/pages/system-administration/instances/list/page-sys-admin-instances-list';

import LayoutSetSysAdminInstanceDetails from 'components/ui/layout-set/system-administration/layout-set-sys-admin-instance-details';

import PageSysAdminInstanceDetailsView from 'components/pages/system-administration/instances/shared/page-sys-admin-instance-details-view';

import PageSysAdminInstanceMainDetails from 'components/pages/system-administration/instances/details/page-sys-admin-instance-main-details';

import PageSysAdminInstanceBlock from 'components/pages/system-administration/instances/block/page-sys-admin-instance-block';

import PageSysAdminInstanceSubscriptionsList from 'components/pages/system-administration/instances/subscriptions/list/page-sys-admin-instance-subscriptions-list';
import PageSysAdminInstanceSubscriptionDetails from 'components/pages/system-administration/instances/subscriptions/details/page-sys-admin-instance-subscription-details';

import PageSysAdminInstanceSubscriptionInvoiceDetails from 'components/pages/system-administration/instances/subscriptions/invoice/page-sys-admin-instance-subscription-invoice-details';

export default [
  {
    path: '/system-administration/instances',
    component: LayoutSetLevelZero,
    props: {
      index: true,
    },
    children: [
      {
        path: '',
        name: 'system-administration-instances-list',
        meta: { auth: true },
        component: PageSysAdminInstancesList,
        props: route => ({
          page: Number(route.query.page),
          meta: {
            title: 'label.list',
            section: 'label.my_team',
            navigation: {
              index: 'system-administration-instances-list',
              edit: 'system-administration-instance-details',
              // status: 'team-member-status',
            },
          },
        }),
      },
      // end ~ system-administration-instances-list
    ],
  },
  {
    path: '/system-administration/instances/:id(\\d+)',
    component: LayoutSetSysAdminInstanceDetails,
    meta: { auth: true },
    props: route => ({
      id: route.params.id,
      meta: {
        navigation: {
          index: 'system-administration-instances-list',
          status: 'team-member-status',
        },
      },
    }),
    children: [
      {
        path: '',
        props: true,
        component: PageSysAdminInstanceDetailsView,
        children: [
          {
            path: 'details',
            name: 'system-administration-instance-details',
            meta: { auth: true },
            component: PageSysAdminInstanceMainDetails,
            props: route => ({
              id: route.params.id,
              meta: {
                title: 'label.instance_details',
                section: 'label.system_administration',
                navigation: {
                  back: 'system-administration-instances-list',
                },
              },
            }),
          }, // end ~ details
          {
            path: 'purchases',
            name: 'system-administration-instance-purchases',
            meta: { auth: true },
            component: PageSysAdminInstanceSubscriptionsList,
            props: route => ({
              id: route.params.id,
              meta: {
                title: 'label.purchases',
                section: 'label.system_administration',
                navigation: {
                  back: 'system-administration-instances-list',
                  details: 'system-administration-instance-purchase-details',
                },
              },
            }),
            children: [
              {
                path: 'details/:subscription_id(\\d+)',
                name: 'system-administration-instance-purchase-details',
                component: PageSysAdminInstanceSubscriptionDetails,
                props: route => ({
                  instanceID: route.params.id,
                  subscriptionID: route.params.subscription_id,
                  meta: {
                    title: 'label.purchase_details',
                    section: 'label.system_administration',
                    navigation: {
                      cancel: 'system-administration-instance-purchases',
                      details: 'system-administration-instance-purchase-invoice-details',
                    },
                  },
                }),
                children: [
                  {
                    path: 'invoice/:invoice_id(\\d+)',
                    name: 'system-administration-instance-purchase-invoice-details',
                    component: PageSysAdminInstanceSubscriptionInvoiceDetails,
                    props: route => ({
                      instanceID: route.params.id,
                      subscriptionID: route.params.subscription_id,
                      invoiceID: route.params.invoice_id,
                      meta: {
                        title: 'label.invoice_details',
                        section: 'label.system_administration',
                        navigation: {
                          back: 'system-administration-instance-purchase-details',
                        },
                      },
                    }),
                  },
                ],
              }, // end ~ details
            ],
          }, // end ~ purchases
          {
            path: 'block',
            name: 'system-administration-instance-block',
            meta: { auth: true },
            component: PageSysAdminInstanceBlock,
            props: route => ({
              id: route.params.id,
              meta: {
                title: 'label.block_instance',
                section: 'label.system_administration',
                navigation: {
                  back: 'system-administration-instances-list',
                },
              },
            }),
          }, // end ~ roles
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/system-administration/router-sys-admin-instances.js